
    import { Options, Vue } from "vue-class-component";

    @Options({
        name: "P4Index",
        components: {},
    })
    export default class P4Index extends Vue {
    }
